import React, {FunctionComponent, useContext, useEffect, useState} from 'react';
import MicrositePageContainer from '../../components/page/MicrositePageContainer';
import {LogoSize} from '../../components/page/PageHeader';
import MicrositeContext from '../../contexts/microsite-context';
import {useNavigate} from 'react-router-dom';
import AppContext from '../../contexts/app-context';
import MicrositeView from '../../components/microsite/MicrositeView';
import Button, {ButtonType} from '../../components/common/Button';
import ResponseErrors from '../../models/ResponseErrors';

const ManageMicrositePage: FunctionComponent = () => {
  const {authUser} = useContext(AppContext);
  const {microsite, service} = useContext(MicrositeContext);
  const nav = useNavigate();
  const [enableVoting, setEnableVoting] = useState<boolean>(microsite.config.enableVoting === true);
  const [isSavingConfig, setIsSavingConfig] = useState<boolean>(false);
  const [configError, setConfigError] = useState<string | null>(null);

  useEffect(() => {
    if (authUser === null) nav('/');
  }, [authUser, nav]);

  useEffect(() => {
    setEnableVoting(microsite.config.enableVoting === true);
  }, [microsite.config.enableVoting]);

  // const viewMode = authUser !== null && service.isMicrositeManager(authUser, microsite.id) ? ViewMode.Edit : ViewMode.View;

  const managedListIxes: Array<number> = [];
  if (authUser !== null) {
    microsite.lists.forEach((list, ix) => {
      if (service.isListManager(authUser, list.id)) managedListIxes.push(ix);
    });
  }

  return (
    <MicrositePageContainer logoSize={LogoSize.Small} padded={false}>
      <div className="txt-center m-t">
        <Button type={ButtonType.Secondary} onClick={() => nav('/edit')}>
          Edit Labels & Links
        </Button>
        {authUser !== null && service.isMicrositeManager(authUser, microsite.id) && (
          <div className="m-t">
            <label style={{display: 'inline-flex', alignItems: 'center', gap: '8px'}}>
              <input
                type="checkbox"
                checked={enableVoting}
                onChange={e => setEnableVoting(e.target.checked)}
              />
              Enable Voting Mode
            </label>
            <div className="m-t-sm">
              <Button
                type={ButtonType.Secondary}
                disabled={isSavingConfig || enableVoting === (microsite.config.enableVoting === true)}
                onClick={() => {
                  setIsSavingConfig(true);
                  setConfigError(null);
                  service.saveConfig(authUser, microsite, {enableVoting}).catch((e: Error) => {
                    if (e instanceof ResponseErrors) {
                      setConfigError(e.errors.join(', '));
                    } else {
                      setConfigError('Unable to save config');
                    }
                  }).finally(() => {
                    setIsSavingConfig(false);
                  });
                }}
              >
                {isSavingConfig ? 'Saving...' : 'Save Settings'}
              </Button>
            </div>
            {configError && <div className="m-t-sm">{configError}</div>}
          </div>
        )}
      </div>
      <MicrositeView microsite={microsite}
                     listIxes={microsite.lists.map((_, ix) => ix)}
                     managedListIxes={managedListIxes}
      />
    </MicrositePageContainer>
  );
}

export default ManageMicrositePage;
